import React, { useEffect, useReducer, useState } from 'react';
import { IconButton, Button } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { createHotelRoom, updateHotelRoom } from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import './Room-Create.scss';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { useDispatch, useSelector } from 'react-redux';
import { allRoomTypesSelector, fetchAllAccommodations } from '../../../../property/propertySlice';
import './Room-Create.scss';
import { formDataValidate } from '../../../../../utils/formUtils';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import {
  AreaSizeUnits,
  RoomViews,
  smokingPolicies,
} from '../../../../../constants/AccomodationConst';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const RoomCreate = (props) => {
  const { toggleDrawer, room, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const roomTypes = useSelector(allRoomTypesSelector);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    roomTypeId: {
      value: '',
      fieldName: 'Room Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    number: {
      value: '',
      fieldName: 'Room Number',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    area: {
      value: '',
      fieldName: 'Room Area',
      errors: {},
      validations: ['positiveOnly'],
      tab: 0,
    },
    areaSizeUnit: {
      value: '',
      fieldName: 'Area Size Unit',
      errors: {},
      validations: [],
      tab: 0,
    },
    roomView: {
      value: '',
      fieldName: 'Room View',
      errors: {},
      validations: [],
      tab: 0,
    },
    isSmokingAllowed: {
      value: '',
      fieldName: 'Smoking Policy',
      errors: {},
      validations: [],
      tab: 0,
    },
    maxOccupancy: {
      value: '',
      fieldName: 'Maximum Occupants',
      errors: {},
      validations: ['positiveOnly', 'validPureNumber'],
      tab: 0,
    },
    houseKeepingDaySection: {
      value: '',
      fieldName: 'Day Section',
      errors: {},
      validations: ['positiveOnly'],
      placeholder: 'Day Section (Ex: 01, 02)',
      tab: 0,
    },
    houseKeepingEveningSection: {
      value: '',
      fieldName: 'Evening Section',
      errors: {},
      validations: ['positiveOnly'],
      placeholder: 'Evening Section (Ex: 01, 02)',
      tab: 0,
    },
  });

  const emptyAllowedFields = ['area', 'maxOccupancy'];

  useEffect(() => {
    if (room) {
      const currFields = { ...formData };
      for (let field in currFields) {
        if (emptyAllowedFields.includes(field) && room[field] === 0) {
          currFields[field].value = '';
        } else {
          currFields[field].value = room[field];
        }
      }
      setFormData(currFields);
    }
  }, [room]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        const payload = { isActive: true, isAdultRequired: false };

        for (let field in formData) {
          if (emptyAllowedFields.includes(field) && formData[field].value === '') {
            payload[field] = 0;
          } else {
            payload[field] = formData[field].value;
          }
        }

        if (room) {
          payload.id = room.id;
          await updateHotelRoom(payload, hotelId, language);
          notificationManager('success', 'Room updated successfully');
        } else {
          await createHotelRoom(payload, hotelId, language);
          notificationManager('success', 'Room created successfully');
        }
        dispatch(fetchAllAccommodations(hotelId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          room
            ? notificationManager('danger', 'Room updation failed')
            : notificationManager('danger', 'Room creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='room-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{room ? 'Edit Room' : 'Add Room'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-6'>
              <div className='page-title-secondary'>Details</div>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-2'>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomSelect
                  item={formData.roomTypeId}
                  handleInputChange={(e) => {
                    setFormData({ roomTypeId: e });
                  }}
                  options={roomTypes}
                  labelPrefix='Select'
                  hideNullOption={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.number}
                  handleInputChange={(e) => {
                    setFormData({ number: e });
                  }}
                  maxLength={10}
                  type='alphanumeric'
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <CustomTextField
                  item={formData.description}
                  handleInputChange={(e) => {
                    setFormData({ description: e });
                  }}
                  multiline={true}
                  maxLength={450}
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  type='number'
                  item={formData.area}
                  min={0}
                  max={100000000}
                  handleInputChange={(e) => {
                    setFormData({ area: e });
                  }}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomSelect
                  item={formData.areaSizeUnit}
                  handleInputChange={(e) => {
                    setFormData({ areaSizeUnit: e });
                  }}
                  options={AreaSizeUnits}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomSelect
                  item={formData.roomView}
                  handleInputChange={(e) => {
                    setFormData({ roomView: e });
                  }}
                  options={RoomViews}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomSelect
                  item={formData.isSmokingAllowed}
                  handleInputChange={(e) => {
                    setFormData({ isSmokingAllowed: e });
                  }}
                  options={smokingPolicies}
                  hideNullOption={smokingPolicies.length}
                />
              </div>
            </div>
            <div className='page-title-secondary mt-4'>Occupancy</div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.maxOccupancy}
                  handleInputChange={(e) => {
                    setFormData({ maxOccupancy: e });
                  }}
                  type='number'
                  min={0}
                  max={99}
                />
              </div>
            </div>{' '}
            {/* temporarily disabled */}
            {/* <div className="page-title-secondary mt-4">Housekeeping</div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <CustomTextField
                  item={formData.houseKeepingDaySection}
                  handleInputChange={(e) => {
                    setFormData({ houseKeepingDaySection: e });
                  }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <CustomTextField
                  item={formData.houseKeepingEveningSection}
                  handleInputChange={(e) => {
                    setFormData({ houseKeepingEveningSection: e });
                  }}
                />
              </div>
            </div> */}
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={isTabInValid}
            >
              {room ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default RoomCreate;
